(function() {
    'use strict';

    angular
        .module('getwellApp')
        .controller('EndCustomerDetailController', EndCustomerDetailController);

    EndCustomerDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'EndCustomer'];

    function EndCustomerDetailController($scope, $rootScope, $stateParams, previousState, entity, EndCustomer) {
        var vm = this;

        vm.endCustomer = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('getwellApp:endCustomerUpdate', function(event, result) {
            vm.endCustomer = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
